import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map , catchError, tap} from 'rxjs/operators';
import {  Observable , of} from 'rxjs';
import { EnvironmentService } from '../environment.service';
@Injectable({
  providedIn: 'root'
})
export class WhatsappEmbeddedServiceService {
  httpOptions: any;
  apiUrl: any;
  username: any;
  password: any;
  userId:any;
  // subscriberId:any;
  constructor(private http: HttpClient, private envService: EnvironmentService) { 
    this.apiUrl = this.envService.read('apiUrl');
    this.username = this.envService.getCredential('username');
    this.password = this.envService.getCredential('password');

    // this.subscriberId = localStorage.getItem('subscriberId');
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`,
        // "access-token": this.sharedService.token,
      }),
    };
  }
  private handleError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err && err.status === 401) {
      return of(err.error);
    }
    throw err.error;
  }
  validateWeb(args): Observable<any>  {
    console.log("args", args)
    return this.http
      .post<any>(`${this.apiUrl}/whatsapp/validate/webhook`, args,
      this.httpOptions) 
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
  whatsappembedded(args): Observable<any> {
    console.log("args11", args)
    this.httpOptions.params = new HttpParams().set('subscriberId', args.subscriberId);
    return this.http
      .post<any>(
        `${this.apiUrl}/whatsapp/cloud/register`,
        args,
        this.httpOptions
      )
      .pipe(
        tap(),
        catchError((error) => {
          this.handleError(error);
          return of(error);
        })
      );
  }
  fileupload(args): Observable<any> {
    this.httpOptions.params = null;
    return this.http
      .post<any>(
        `${this.apiUrl}/whatsapp/upload/attachment`,
        args,
        this.httpOptions
      )
      .pipe(
        tap(),
        catchError((error) => {
          this.handleError(error);
          return of(error);
        })
      );
  }
  getWabaLocalStorages(): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/whatsapp/waba/localstorages`,
        this.httpOptions
      )
      .pipe(
        tap(),
        catchError((error) => {
          // this.handleError(error);
          return of(error);
        })
      );
  }
}